/* SuperFAE Motion — GSAP + ScrollTrigger animations
   Theme: Craft + Animaciones | v1.1 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  var ease = 'power3.out';
  var easeBack = 'back.out(1.4)';

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* Nav auto-hide on scroll */
  (function navHide() {
    var header = q('.sticky-header') || q('header.header-wrapper') || q('.header-wrapper');
    if (!header) return;
    var lastY = 0;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > 200 && y > lastY + 5) {
          header.classList.add('sf-nav-hidden');
        } else if (y < lastY - 5) {
          header.classList.remove('sf-nav-hidden');
        }
        lastY = y;
        ticking = false;
      });
    });
  })();

  /* Manifesto entrance — Abanico (fan spread) */
  (function manifestoAnim() {
    var section = q('.sf-manifesto');
    if (!section) return;

    var head = q('.sf-manifesto-head', section);
    var slides = qa('.sf-slide', section);

    var tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: 'top 75%', once: true }
    });

    if (head) {
      tl.from(head, { y: 20, opacity: 0, duration: 0.5, ease: ease }, 0);
    }
    if (slides.length >= 3) {
      tl.from(slides[1], {
        opacity: 0, scale: 0.92, duration: 0.5, ease: ease
      }, 0.15);
      tl.from(slides[0], {
        opacity: 0, x: 60, scale: 0.92, duration: 0.5, ease: ease
      }, 0.27);
      tl.from(slides[2], {
        opacity: 0, x: -60, scale: 0.92, duration: 0.5, ease: ease
      }, 0.27);
    } else if (slides.length) {
      tl.from(slides, {
        opacity: 0, scale: 0.92, duration: 0.5, stagger: 0.08, ease: ease
      }, 0.15);
    }
  })();

  /* Collection grid entrance */
  (function collectionAnim() {
    var section = q('.sf-collection-grid');
    if (!section) return;

    var heading = q('h2, .sf-heading', section);
    var cards = qa('.sf-product-card, .card-wrapper, .card', section);

    if (heading) {
      gsap.from(heading, {
        y: 30, opacity: 0, duration: 0.7, ease: ease,
        scrollTrigger: { trigger: section, start: 'top 80%', once: true }
      });
    }
    if (cards.length) {
      gsap.from(cards, {
        y: 50, opacity: 0, scale: 0.94,
        duration: 0.5, stagger: 0.08, ease: easeBack,
        scrollTrigger: { trigger: section, start: 'top 70%', once: true }
      });
    }
  })();

  /* Ventajas cards stagger */
  (function ventajasAnim() {
    var section = q('.sf-ventajas');
    if (!section) return;

    var eyebrow = q('.sf-ventajas-eyebrow', section);
    var heading = q('.sf-ventajas-heading', section);
    var intro = q('.sf-ventajas-intro', section);
    var cards = qa('.sf-ventajas-card', section);

    var tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: 'top 75%', once: true }
    });

    if (eyebrow) tl.from(eyebrow, { y: 20, opacity: 0, duration: 0.5, ease: ease }, 0);
    if (heading) tl.from(heading, { y: 30, opacity: 0, duration: 0.6, ease: ease }, 0.1);
    if (intro) tl.from(intro, { y: 20, opacity: 0, duration: 0.5, ease: ease }, 0.25);
    if (cards.length) {
      tl.from(cards, {
        y: 40, opacity: 0, scale: 0.95, rotation: -1,
        duration: 0.5, stagger: 0.1, ease: easeBack
      }, 0.4);
    }
  })();

  /* Steps timeline entrance */
  (function stepsAnim() {
    var section = q('.sf-steps');
    if (!section) return;

    var header = q('.sf-steps-header', section);
    var steps = qa('.sf-step', section);
    var mainBtn = q('.sf-main-btn-wrap, .sf-main-btn', section);

    if (header) {
      gsap.from(header.children, {
        y: 25, opacity: 0, duration: 0.5, stagger: 0.12, ease: ease,
        scrollTrigger: { trigger: section, start: 'top 80%', once: true }
      });
    }
    if (steps.length) {
      gsap.from(steps, {
        x: -30, opacity: 0, duration: 0.5, stagger: 0.12, ease: easeBack,
        scrollTrigger: { trigger: steps[0], start: 'top 80%', once: true }
      });
      steps.forEach(function (step, i) {
        ScrollTrigger.create({
          trigger: step,
          start: 'top 60%',
          once: true,
          onEnter: function () {
            var dot = q('.sf-step-num', step);
            if (dot) dot.classList.add('sf-active-step');
          }
        });
      });
    }
    if (mainBtn) {
      gsap.from(mainBtn, {
        y: 20, opacity: 0, scale: 0.95, duration: 0.5, ease: easeBack,
        scrollTrigger: { trigger: mainBtn, start: 'top 85%', once: true }
      });
    }
  })();

  /* Footer CTA entrance */
  (function footerAnim() {
    var section = q('.sf-footer');
    if (!section) return;

    var eyebrow = q('.sf-footer-eyebrow', section);
    var heading = q('.sf-footer-heading', section);
    var sub = q('.sf-footer-sub', section);
    var btn = q('.sf-footer-btn', section);
    var nav = q('.sf-footer-nav', section);

    var tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: 'top 80%', once: true }
    });

    if (eyebrow) tl.from(eyebrow, { y: 20, opacity: 0, duration: 0.4, ease: ease }, 0);
    if (heading) tl.from(heading, { y: 30, opacity: 0, duration: 0.6, ease: ease }, 0.1);
    if (sub) tl.from(sub, { y: 20, opacity: 0, duration: 0.4, ease: ease }, 0.3);
    if (btn) tl.from(btn, { y: 16, opacity: 0, scale: 0.95, duration: 0.4, ease: easeBack }, 0.5);
    if (nav) tl.from(nav, { y: 20, opacity: 0, duration: 0.5, ease: ease }, 0.4);
  })();

  /* ScrollTrigger refresh after fonts */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      ScrollTrigger.refresh();
    });
  }
})();
